import React, { useEffect, useState } from "react";
import { GET } from "../../utils/requests";
import { Box, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import VendorFinder from "../vendor_finder/Main";
import InvoiceNumber from "../invoice_number/Main";
import InvoiceDate from "../invoice_date/Main";
import InvoiceAmount from "../invoice_amount/Main";
import ItemNumberFinder from "../item_number_finder/Main";
import ItemNameFinder from "../item_name_finder/Main";
import Quantity from "../quantity/Main";
import UnitPrice from "../unit_price/Main";
import Subtotal from "../subtotal/Main";
import CategorySelector from "../category_selector/Main";

const Main = ({ account_id, invoice_info, invoice_line_items, onChangeInvoiceInfo, onChangeLineItems }) => {
  const [value, setValue] = useState({...invoice_info})
  const [line_items, setLineItems] = useState([...invoice_line_items])
  const [tree_options, setTreeOptions] = useState(null)

  useEffect(() => {
    GET({
      url: `/references/categories.json?account_id=${account_id}`,
      success: (data) => {
        setTreeOptions(data)
      }
    })
  }, [])

  const updateValue = (key, updatedData) => {
    setValue(prevValue => {
      const new_value = {
        ...prevValue,
        [key]: {
          ...prevValue[key],
          current: {
            ...prevValue[key]?.current,
            ...updatedData,
          },
        },
      };

      if(onChangeInvoiceInfo) {
        onChangeInvoiceInfo(new_value)
      }

      return new_value;
    });
  };

  const updateLineItem = (index, key, updatedData) => {
    setLineItems(prevLineItems => {
      const newLineItems = [...prevLineItems];
      newLineItems[index] = {
        ...newLineItems[index],
        [key]: {
          ...newLineItems[index][key],
          current: {
            ...newLineItems[index][key]?.current,
            ...updatedData,
          },
        },
      };

      if(onChangeLineItems) {
        onChangeLineItems(newLineItems)
      }

      return newLineItems;
    });
  };

  const removeLineItem = (index) => {
    setLineItems(prevLineItems => {
      const newLineItems = [...prevLineItems];
      newLineItems.splice(index, 1);

      if(onChangeLineItems) {
        onChangeLineItems(newLineItems)
      }

      return newLineItems;
    });
  };


  const onAddLineItem = () => {
    const empty_obj = { current: { value: "" } };
    setLineItems(prevLineItems => {
      const newLineItems = [
        ...prevLineItems,
        {
          item_number: {...empty_obj},
          item_name: {...empty_obj},
          qty: {...empty_obj},
          unit_price: {...empty_obj},
          category: {...empty_obj},
          subtotal: {...empty_obj},
        }
      ]

      if(onChangeLineItems) {
        onChangeLineItems(newLineItems)
      }

      return newLineItems;
    });
  }

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <VendorFinder
          default_value={value?.vendor?.reference?.reference_id}
          value={value.vendor?.current}
          show_address={false}
          onChange={(val) => updateValue('vendor', val)}
        />
        <br/>
        <InvoiceNumber
          default_value={value?.invoice_number?.reference?.current_value}
          value={value.invoice_number?.current}
          show_message={false}
          onChange={(val) => updateValue('invoice_number', val)}
        />
        <br/>
        <br/>
        <InvoiceDate
          default_value={value?.invoice_date?.reference?.current_value}
          value={value.invoice_date?.current}
          show_inline_warning={false}
          onChange={(val) => updateValue('invoice_date', val)}
        />
        <br/>
        <br/>
        <InvoiceAmount
          default_value={value?.total_amount?.reference?.current_value}
          value={value.total_amount?.current}
          show_message={false}
          onChange={(val) => updateValue('total_amount', val)}
        />
        <hr/>
        Line Items
        <table className="table table-bordered line-items-table">
          <thead>
            <tr>
              <th style={{width: "200px"}}>Item Number</th>
              <th>Item Name</th>
              <th style={{width: "270px"}}>Category</th>
              <th style={{width: "70px"}}>QTY</th>
              <th style={{width: "120px"}}>Unit Price</th>
              <th style={{width: "100px"}}>Subtotal</th>
              <th style={{width: "40px"}}></th>
            </tr>
          </thead>
          <tbody>
            {line_items.map((line_item, index) => (
              <tr>
                <td>
                  <ItemNumberFinder
                    default_value={line_item.item_number?.reference?.reference_id}
                    vendor_id={value?.vendor?.current?.value}
                    value={line_item.item_number?.current}
                    onChange={(val) => {
                      const local_val = val || {id: "", value: "", name: "", label: ""};
                      updateLineItem(index, 'item_number', local_val);
                      if(val !== null) {
                        const ref_val = {...local_val, name: local_val?.item_name};
                        updateLineItem(index, 'item_name', ref_val);
                      } else {
                        updateLineItem(index, 'item_name', local_val);
                      }
                    }}
                  />
                </td>
                <td>
                  <ItemNameFinder
                    vendor_id={value?.vendor?.current?.value}
                    value={line_item.item_name?.current}
                    onChange={(val) => {
                      const local_val = val || {id: "", value: "", name: "", label: ""};
                      updateLineItem(index, 'item_name', local_val);
                      if(val !== null) {
                        const ref_val = {...local_val, name: local_val?.item_number};
                        updateLineItem(index, 'item_number', ref_val);
                      } else {
                        updateLineItem(index, 'item_number', local_val);
                      }
                    }}
                  />
                </td>
                <td>
                  {tree_options && <>
                    <CategorySelector
                      default_value={line_item.category?.reference?.reference_id}
                      tree_options={tree_options}
                      value={line_item.category?.current}
                      onChange={(val) => {
                        const local_val = val || {id: "", value: "", name: "", label: ""};
                        updateLineItem(index, 'category', local_val)
                      }}
                    />
                  </>}
                </td>
                <td>
                  <Quantity
                    default_value={line_item.quantity?.reference?.current_value}
                    value={line_item.quantity?.current}
                    onChange={(val) => updateLineItem(index, 'quantity', val)}
                  />
                </td>
                <td>
                  <UnitPrice
                    default_value={line_item.unit_price?.reference?.current_value}
                    value={line_item.unit_price?.current}
                    onChange={(val) => updateLineItem(index, 'unit_price', val)}
                  />
                </td>
                <td>
                  <Subtotal value={{value: `${((parseFloat(line_item.quantity?.current?.value) || 0.00) * (parseFloat(line_item.unit_price?.current?.value) || 0)).toFixed(2)}`}} />
                </td>
                <td className="text-center">
                  <Button
                    color="warning"
                    size="small"
                    className="mt-2"
                    onClick={() => removeLineItem(index)}
                  >
                    <DeleteIcon />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="5">Total</td>
              <td>
                {(line_items.reduce((acc, line_item) => {
                  return acc + (parseFloat(line_item.qty?.current?.value) || 0.00) * (parseFloat(line_item.unit_price?.current?.value) || 0);
                }, 0.00)).toFixed(2)}
              </td>
              <td></td>
            </tr>
            <tr>
              <td colSpan="7" className="text-end">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={onAddLineItem}
                >
                  Add Line Item
                </Button>
              </td>
            </tr>
          </tfoot>
        </table>
      </Box>
    </>
  )
}

export default Main;